export default __webpack_public_path__ + "static/driver-657c76a4e24623d7ca252696f61ccd88.png";